var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScopeToggle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 48,
    viewBox: "0 0 92 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_666_2071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.75 0 0 10.75 0 24C0 37.25 10.75 48 24 48H68C81.25 48 92 37.25 92 24C92 10.75 81.25 0 68 0H24ZM68 8C72.2435 8 76.3131 9.68571 79.3137 12.6863C82.3143 15.6869 84 19.7565 84 24C84 28.2435 82.3143 32.3131 79.3137 35.3137C76.3131 38.3143 72.2435 40 68 40C63.7565 40 59.6869 38.3143 56.6863 35.3137C53.6857 32.3131 52 28.2435 52 24C52 19.7565 53.6857 15.6869 56.6863 12.6863C59.6869 9.68571 63.7565 8 68 8Z",
    fill: "url(#paint0_linear_666_2071)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_666_2071",
    x: 0,
    y: 0,
    width: 92,
    height: 49.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_666_2071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_2071",
    x1: 80.6677,
    y1: 58.2633,
    x2: -1.24266,
    y2: 31.9534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E8E3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E3DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScopeToggle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ScopeToggle.9be51874.svg";
export { ForwardRef as ReactComponent };